
  <div [formGroup]="orderForm">

    <button mat-button (click)="addPoint()">Adicionar Coordenada</button>

    <div formArrayName="items" *ngFor="let item of _items.controls; let i = index;">
      <div [formGroupName]="i">

        <mat-form-field>
          <input matInput type="number" formControlName="X" placeholder="X">
        </mat-form-field>
        <mat-form-field>
          <input matInput type="number" formControlName="Y" placeholder="Y">
        </mat-form-field>
        <button mat-icon-button color="primary" (click)="remove(i)" aria-label="Remover">
          <mat-icon>remove_circle</mat-icon>
        </button>

      </div>

    </div>

  </div>

